// sagas.js
import { call, put, takeLatest } from 'redux-saga/effects';

import {
  POST_ALTERNATIVE_PRODUCTS_REQUEST,
  postAlternativeProductsSuccess,
  postAlternativeProductsFailure,
} from '../actions/fetchAlternativeProductsAction';
import { postRequest } from 'api/apiCall';
import captureCustomSentryEvent from "Sentry/captureCustomSentryEvent";

// API Request Function
function* postAlternativeProductsAPI(action) {
  try {
    const { variantId, mfrItemCodes } = action.payload;
    const payload = {
      variant_id: variantId,
      mfr_item_codes: mfrItemCodes,
    };
    const response = yield call(postRequest, `/products/alternative-products/`, payload);
    if (response && response.success !== false && !response.error) {
      return response;
    } else {
      const message = (response && response.message) || 'Something went wrong';
      const error = { message };
      throw error;
    }
  } catch (error) {
    captureCustomSentryEvent("postAlternativeProductsAPI", error);
    throw error;
  }
}

// Worker Saga
function* postAlternativeProducts(action) {
  try {
    const response = yield call(postAlternativeProductsAPI, action);
    yield put(postAlternativeProductsSuccess(response));
  } catch (error) {
    const errPayload = error?.response?.data?.message || error?.message || 'Request failed';
    yield put(postAlternativeProductsFailure(errPayload));
  }
}

// Watcher Saga
function* watchPostAlternativeProducts() {
  yield takeLatest(POST_ALTERNATIVE_PRODUCTS_REQUEST, postAlternativeProducts);
}

export default watchPostAlternativeProducts;


